import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Fashion() {
  return <ImageCollectionPage title="Fashion" path="/culture/fashion" collection="culture_fashion" />;
}
